import { render, staticRenderFns } from "./singleSlider.vue?vue&type=template&id=6c160e34&"
import script from "./singleSlider.vue?vue&type=script&lang=js&"
export * from "./singleSlider.vue?vue&type=script&lang=js&"
import style0 from "./singleSlider.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports